import styled from 'styled-components';

export const StyledVoiceCloningList = styled.div`
  .voice-cloning-list-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .voice-search-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  .voice-search-input {
    flex: 1;
  }
`;
